import apiClient from './apiClient';

const baseUrl = process.env.REACT_APP_BASE_URL;

class SubscriptionService {
  // Get current user subscription
  async getMySubscription() {
    try {
      const response = await apiClient.get(`${baseUrl}/subscription/my-subscription`);
      return response.data; 
    } catch (error) {
      console.error('Error fetching subscription:', error);
      throw error;
    }
  }

  // Get user subscription history
  async getMySubscriptionHistory() {
    try {
      const response = await apiClient.get(`${baseUrl}/subscription/my-subscription-history`);
      return response.data;
    } catch (error) {
      console.error('Error fetching subscription history:', error);
      throw error;
    }
  }
}

export default new SubscriptionService();
